var $99b345867a868892$exports = {};
$99b345867a868892$exports = {
  "backButton": args => "Gr\u012F\u017Eti \u012F ".concat(args.prevMenuButton),
  "moreActions": "Daugiau veiksm\u0173",
  "unavailable": "Nepasiekiama, nor\u0117dami gauti daugiau informacijos, i\u0161skleiskite"
};
export { $99b345867a868892$exports as default };